import * as actionTypes from "./actionTypes";
import * as APIs from "./apis";
import { loaderStart, loaderEnd, notification } from "../../components/loader";
import { getStoredAuth, getStoredSubject, storeAuth, storeSubject, clearStoredAuth, clearStoredSubject } from "../../utils/authStorage";


//APIS

export const onUserCheck = (username, camera) => {
    return async (dispatch) => {
        loaderStart()
        let res = await APIs.userCheck(username, camera)
        if (res.status) {
            dispatch(updateExam(res.data))
            storeSubject(res.data);
            if (!res.data?.userCurrentSlotData?.length && !res.data?.userTodaySlotData?.length) {
                notification(false, "The Aadhar number is not mapped for Today Exam")
            } else if (res.data?.userCurrentSlotData?.length == 0) {
                notification(false, "You do not a have any exam now.")
            }
            else if (res.data?.userCurrentSlotData?.length) {
                if (res.data?.userCurrentSlotData[0].completed) {
                    notification(false, "You have finished the exam")
                }
                else if (res.data?.userCurrentSlotData[0].entered) {
                    notification(false, "You have already entered the exam")
                }

            }
            loaderEnd()
        }
        else {
            notification(false, res.message)
        }
    }
};

export const onLogin = (username, password, navigate, camera) => {
    return async (dispatch) => {
        loaderStart()
        let res = await APIs.handleLogin(username, password, camera)
        if (res.status) {
            // The server sends the exams of the person who actually logged in; they replace what the Aadhaar step
            // fetched, which may have been for another Aadhaar typed earlier on this computer
            const { examDetails, ...authData } = res.data || {}
            if (examDetails) {
                dispatch(updateExam(examDetails))
                storeSubject(examDetails)
            }
            dispatch(updateAuthData(authData))
            storeAuth(authData)
            // if(process.env.REACT_APP_SKIP_LANGUAGE){
            //     navigate("/instruction")
            // }
            // else{
                
            // }
            navigate("/dashboard")
            loaderEnd()
        }
        else {
            notification(false, res.message)
        }
    }
};

export const updateAuthData = (data) => {
    return {
        type: actionTypes.UPDATE_AUTH_DATA,
        payload: data,
    };
};

export const updateExam = (data) => {
    return {
        type: actionTypes.UPDATE_EXAM,
        payload: data,
    };
};





export const getDataFromLocal = () => {
    return async (dispatch) => {
        let data = getStoredAuth();
        if (data) {
            dispatch(updateAuthData(data))
        }

        let data2 = getStoredSubject() || {};
        if (data2) {
            dispatch(updateExam(data2))
        }
    }
};

// The Aadhaar number was changed after the Aadhaar step: what was fetched is for the old number, so the
// login starts again from that step
export const resetExamCheck = () => {
    return (dispatch) => {
        clearStoredSubject()
        dispatch(updateExam({}))
    }
}

export const onLogout = (navigate) => {
    return async (dispatch) => {
        clearStoredAuth()
        dispatch(updateAuthData(null))
        dispatch(updateExam({}))
        navigate("/")
    }
}
